var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9966 0.996094C9.93329 0.996094 4.99756 5.93184 4.99756 11.9951C4.99755 22.6638 15.3765 30.7746 15.3765 30.7746C15.5537 30.916 15.7736 30.993 16.0003 30.993C16.2269 30.993 16.4469 30.916 16.624 30.7746C16.624 30.7746 27.003 22.6638 27.003 11.9951C27.003 5.93184 22.0599 0.996094 15.9966 0.996094ZM15.9966 2.99659C20.979 2.99659 25.0025 7.01271 25.0025 11.9951C25.0025 20.723 17.0993 27.6187 16.004 28.5527C14.9139 27.6234 6.99805 20.7264 6.99805 11.9951C6.99805 7.01271 11.0142 2.99659 15.9966 2.99659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9966 6.99756C13.247 6.99756 10.999 9.24553 10.999 11.9951C10.999 14.7447 13.247 17 15.9966 17C18.7462 17 21.0015 14.7447 21.0015 11.9951C21.0015 9.24553 18.7461 6.99756 15.9966 6.99756ZM15.9966 8.99805C17.6653 8.99805 19.001 10.3264 19.001 11.9951C19.001 13.6638 17.6653 14.9995 15.9966 14.9995C14.3279 14.9995 12.9995 13.6638 12.9995 11.9951C12.9995 10.3264 14.3279 8.99805 15.9966 8.99805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.31b4d2a4b4d0c971838d11d13912d520.svg";
export { ForwardRef as ReactComponent };